import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ImageSwiperModalStep } from '../../interfaces';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  GPU_MEDIA_QUERIES,
  GpuMediaQueryBreakpoints,
} from '@geneplanet/ngx-ui/src/lib/layout';

@UntilDestroy()
@Component({
  selector: 'app-image-swiper-modal',
  templateUrl: './image-swiper-modal.component.html',
  styleUrls: ['./image-swiper-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageSwiperModalComponent {
  @HostBinding('class') classAttribute = 'overflow-visible';
  @ViewChild('container') container: ElementRef;

  @Input() steps: ImageSwiperModalStep[] = [];

  protected isMobile = false;
  protected activePage = 0;

  constructor(
    protected modal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe(GPU_MEDIA_QUERIES[GpuMediaQueryBreakpoints.SM_DOWN])
      .pipe(untilDestroyed(this))
      .subscribe((value: BreakpointState) => {
        this.isMobile = value.matches;
        this.cdr.markForCheck();
      });
  }

  get numberOfSlides() {
    return Object.keys(this.steps).length;
  }

  protected onPageChanged(activePage: number) {
    this.activePage = activePage;
  }
}
